import { setCustomAttribute } from "@src/helpers/monitoring";

export default function startCheckSameSiteIframe() {
  window.addEventListener("message", function(event) {
    if (
      event.data &&
      event.data.startsWith &&
      event.data.startsWith("CookiesDefaultToSameSiteNone")
    ) {
      const result = event.data.split(":")[1];
      setCustomAttribute("CookiesDefaultToSameSiteNone", result);
    }
  });

  const iframe = document.createElement("iframe");
  iframe.src = `https://assets.asosservices.com/asos-ui/cookie/iframe-samesite.html`;
  iframe.width = 0;
  iframe.height = 0;
  iframe.style.display = "none";
  document.body.appendChild(iframe);
}
